import { faToggleOff } from "@fortawesome/free-solid-svg-icons";
import styles from "./app-switch.style.module.scss";
export interface Input extends Omit<Marko.HTML.Input, "type"> {
  off: string;
  on: string;
}

const/{ on, off, ...checkboxInput }=input

label class=styles.label
  span -- ${off}
  span class=styles.appSwitch
    // `switch` announces the on/off state a checkbox only implies, which the
    // visible "HTML"/"Concise" pair does not convey on its own.
    input ...checkboxInput type="checkbox" role="switch"
    fa-icon=faToggleOff
  span -- ${on}
